import theme from "assets/theme";
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { ScrollView, StyleSheet, View } from "react-native";
import {
  SCREEN_DASHBOARD_ALERTS,
  SCREEN_DASHBOARD_BCP_INFO,
  SCREEN_DASHBOARD_HOME,
  SCREEN_DASHBOARD_ORGANIZATION_SETTINGS,
  SCREEN_DASHBOARD_OTHER_CONTACTS,
  SCREEN_DASHBOARD_PEOPLE,
  SCREEN_DASHBOARD_PLACES,
  SCREEN_DASHBOARD_PLATFORMS,
  SCREEN_DASHBOARD_TEAMS,
} from "web/constants";
import SideBarItem from "webComponentsScreens/dashboard/SideBarItem.component";
import { OrganizationContext } from "webContext/Organization.context";

const classes = StyleSheet.create({
  primaryMenuItems: {
    flex: 1,
    justifyContent: "flex-start",
  },
});

export default function SideBar(props) {
  const { logout } = props;

  const { organizationColor, currentRoute, setCurrentRoute } =
    useContext(OrganizationContext);

  // Get current route from URL for web
  const getCurrentRouteFromUrl = useCallback(() => {
    const path = window.location.pathname;
    const routeName = path.split("/").pop() || SCREEN_DASHBOARD_HOME;

    // Map URL paths to screen constants
    const routeMap = {
      people: SCREEN_DASHBOARD_PEOPLE,
      "manage-person": SCREEN_DASHBOARD_PEOPLE, // ManagePersonScreen should highlight People menu item
      "other-contacts": SCREEN_DASHBOARD_OTHER_CONTACTS,
      places: SCREEN_DASHBOARD_PLACES,
      alerts: SCREEN_DASHBOARD_ALERTS,
      platforms: SCREEN_DASHBOARD_PLATFORMS,
      "bcp-info": SCREEN_DASHBOARD_BCP_INFO,
      teams: SCREEN_DASHBOARD_TEAMS,
      "organization-settings": SCREEN_DASHBOARD_ORGANIZATION_SETTINGS,
      home: SCREEN_DASHBOARD_HOME,
    };

    return routeMap[routeName] || SCREEN_DASHBOARD_HOME;
  }, []);

  const [selectedItem, setSelectedItem] = useState(() => {
    // Initialize with current route from URL or fallback to home
    return getCurrentRouteFromUrl();
  });

  useEffect(() => {
    if (currentRoute) {
      setSelectedItem(currentRoute);
      setCurrentRoute(null);
    }
  }, [currentRoute, setCurrentRoute]);

  // Listen for URL changes (back/forward buttons, direct navigation)
  useEffect(() => {
    const handlePopState = () => {
      setSelectedItem(getCurrentRouteFromUrl());
    };

    // Set initial route on component mount
    setSelectedItem(getCurrentRouteFromUrl());

    // Listen for browser navigation events
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [getCurrentRouteFromUrl]);

  const stateClasses = useMemo(
    () =>
      StyleSheet.create({
        sideBarWrapper: {
          width: 250,
          height: "100%",
          alignItems: "left",
          borderRightWidth: 2,
          borderRightColor: organizationColor,
          shadowColor: "#000",
          shadowOffset: { width: 1, height: 0 },
          shadowOpacity: 0.25,
          shadowRadius: 3,
        },
        title: {
          fontSize: theme.font.size.header,
          fontWeight: theme.font.weight.semibold,
          padding: 5,
          color: organizationColor,
          textAlign: "center",
        },
      }),
    [organizationColor],
  );

  return (
    <View style={stateClasses.sideBarWrapper}>
      <ScrollView contentContainerStyle={classes.primaryMenuItems}>
        <SideBarItem
          route={SCREEN_DASHBOARD_HOME}
          selectedItem={selectedItem}
          setSelectedItem={setSelectedItem}
        />
        <SideBarItem
          route={SCREEN_DASHBOARD_PEOPLE}
          selectedItem={selectedItem}
          setSelectedItem={setSelectedItem}
        />
        <SideBarItem
          route={SCREEN_DASHBOARD_PLACES}
          selectedItem={selectedItem}
          setSelectedItem={setSelectedItem}
        />
        <SideBarItem
          route={SCREEN_DASHBOARD_PLATFORMS}
          selectedItem={selectedItem}
          setSelectedItem={setSelectedItem}
        />
        <SideBarItem
          route={SCREEN_DASHBOARD_TEAMS}
          selectedItem={selectedItem}
          setSelectedItem={setSelectedItem}
        />
        <SideBarItem
          route={SCREEN_DASHBOARD_ALERTS}
          selectedItem={selectedItem}
          setSelectedItem={setSelectedItem}
        />
        <SideBarItem
          route={SCREEN_DASHBOARD_OTHER_CONTACTS}
          selectedItem={selectedItem}
          setSelectedItem={setSelectedItem}
        />
        <SideBarItem
          route={SCREEN_DASHBOARD_BCP_INFO}
          selectedItem={selectedItem}
          setSelectedItem={setSelectedItem}
        />
        <SideBarItem
          route={SCREEN_DASHBOARD_ORGANIZATION_SETTINGS}
          selectedItem={selectedItem}
          setSelectedItem={setSelectedItem}
        />
      </ScrollView>
      <SideBarItem title="Logout" icon="exit-to-app" onPress={logout} />
    </View>
  );
}
